export { default } from './Checkbox';
export type { ICheckboxProps } from '@rivallapp/native-base';
